import React from 'react';
import Navigation from '../../../layout/Navigation/Navigation';
import UseOrderDetailsPage from './useOrderDetailsPage';
import { FaCheck } from 'react-icons/fa';
import OrderDetailMobile from './Components/OrderDetailMobile';
import { LuDot } from 'react-icons/lu';
import { Link } from 'react-router-dom';
import config from '../../../../config/environment';
import Namsteji_Manikchand_Icon from '../../../../assets/images/Namsteji_Manikchand_Icon.svg';
import OrderRatingReviewSlider from './Components/OrderRatingReviewSlider';
import {
  ORDER_STATUS_CUSTOMER_REJECTED,
  ORDER_STATUS_DELIVERED,
  ORDER_STATUS_ON_THE_WAY,
  ORDER_STATUS_ORDER_RECEIVED,
  ORDER_STATUS_PROCESSING,
} from '../../../../utils/constants';
const SERVER_URL = config.SERVER_URL;
import { MdOutlineFileDownload } from 'react-icons/md';
import { GiCancel } from 'react-icons/gi';
const OrderDetailsPage: React.FC = () => {
  const { states, orderStatusCode, ratingReviewObj } = UseOrderDetailsPage();

  return (
    <>
      <div className='hidden sm:hidden md:hidden lg:block'>
        <div className='items-center justify-center sm:py-3 md:py-8 lg:py-7 '>
          <div className='mx-[.5%] sm:mx-[.5%] md:mx-[1%] lg:mx-[4%] p-3 sm:p-3 md:p-2 lg:p-4 flex'>
            {/* Global Navigation */}
            <Navigation />

            {/* Desktop veiw */}
            <div className='hidden sm:hidden md:block lg:block flex-1 bg-white rounded-xl shadow-md ml-0 lg:ml-6 mt-4 sm:mt-4 md:mt-0 lg:mt-0 border'>
              {/* Header */}
              <div className='flex items-center border-b h-16 px-6'>
                <div className='flex items-center'>
                  <h2 className='text-xl font-medium font-poppins flex items-center'>
                    Order Details
                    <LuDot className='h-8 w-8' />
                  </h2>
                  <span className='text-[#4D4D4D] text-start font-poppins flex justify-center items-center'>
                    {states.ordersDataArr?.transaction_date ? states.ordersDataArr?.transaction_date : ''}
                    <LuDot className='h-8 w-8' />
                    {states.ordersDataArr?.total_qty ? states.ordersDataArr?.total_qty + ' Products' : ''}
                  </span>
                </div>
                <button className='ml-auto text-[#4A2D1A] font-medium font-poppins'>
                  <Link to='/orders/history'> Back to List </Link>
                </button>
              </div>

              {/* Addresses and Summary */}
              <div className='flex flex-col md:flex-row place-content-center p-4 gap-5'>
                {/* Address Section */}
                <div className='flex flex-row w-full md:w-2/3 border rounded'>
                  {/* Billing Address */}
                  {/* <div className='border-r flex-1'>
                    <div className='flex justify-between items-center border-b'>
                      <h3 className='text-[#999999] text-sm uppercase font-poppins p-4'>Billing Address</h3>
                    </div>
                    <div className='p-4'>
                      <p className='font-normal font-poppins'>{states.ordersDataArr?.customer_name}</p>
                      <p className='text-[#666666] text-sm font-poppins mt-2'>
                        {states.ordersDataArr?.billing_address}
                      </p>
                      <p className='text-[#999999] text-xs font-poppins mt-2'>EMAIL</p>
                      <p className='text-sm font-poppins'>
                        {states.ordersDataArr?.contact_email ? states.ordersDataArr?.contact_email : '---'}
                      </p>
                      <p className='text-[#999999] text-xs font-poppins mt-2'>PHONE</p>
                      <p className='text-sm font-poppins'>{states.ordersDataArr?.contact_phone}</p>
                    </div>
                  </div> */}

                  {/* Shipping Address */}
                  <div className='flex-1'>
                    <div className='flex justify-between items-center border-b'>
                      <h3 className='text-[#999999] text-sm uppercase font-poppins p-4'>Shipping Address</h3>
                    </div>
                    <div className='p-4'>
                      <p className='font-normal font-poppins'>{states.ordersDataArr?.customer_name}</p>
                      <p className='text-[#666666] text-sm font-poppins mt-2'>
                        {states.ordersDataArr?.shipping_address}
                      </p>
                      <p className='text-[#999999] text-xs font-poppins mt-2'>EMAIL</p>
                      <p className='text-sm font-poppins'>
                        {states.ordersDataArr?.contact_email ? states.ordersDataArr?.contact_email : '---'}
                      </p>
                      <p className='text-[#999999] text-xs font-poppins mt-2'>PHONE</p>
                      <p className='text-sm font-poppins'>{states.ordersDataArr?.contact_phone}</p>
                    </div>
                  </div>
                </div>

                {/* Order Summary Section */}
                <div className='flex flex-col w-full md:w-1/3 border py-5 md:py-3 rounded'>
                  <div className='border-b'>
                    <div className='pl-1 flex gap-1'>
                      <div className='flex flex-col justify-between text-[#999999] text-xs mb-3 font-poppins'>
                        <span className='flex flex-row'>ORDER ID:</span>
                        <span className='font-normal text-black'>{states.ordersDataArr?.name}</span>
                      </div>
                      <div className='border-l'>
                        <div className='flex flex-col justify-between text-[#999999] text-xs mb-3 font-poppins ml-1'>
                          <span>PAYMENT METHOD:</span>
                          <span className='font-normal pt-2 text-black'>{'Cash'}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='px-4'>
                    <div className='flex justify-between border-b py-1.5 font-poppins'>
                      <span className='text-[#666666]'>Subtotal:</span>
                      <span className='text-black font-medium'>
                        ₹{states.ordersDataArr?.net_total ? Number(states.ordersDataArr.net_total).toFixed(2) : '0.00'}
                      </span>
                    </div>
                    <div className='flex justify-between border-b py-1.5 font-poppins'>
                      {/* <span>Discount{states.ordersDataArr?.additional_discount_percentage ? "(" + states.ordersDataArr?.additional_discount_percentage + '%)' : ''}</span> */}
                      <span className='text-[#666666]'>
                        Discount&nbsp;(
                        {states.ordersDataArr?.additional_discount_percentage})%
                      </span>
                      <span className='font-medium text-black'>
                        ₹
                        {states.ordersDataArr?.discount_amount
                          ? Number(states.ordersDataArr?.discount_amount).toFixed(2)
                          : '0.00'}
                      </span>
                    </div>
                    <div className='flex justify-between border-b text-[#666666] py-1.5 font-poppins'>
                      <span>GST</span>
                      <span className='font-medium text-black'>
                        ₹{states.ordersDataArr?.gst ? Number(states.ordersDataArr?.gst).toFixed(2) : '0.00'}
                      </span>
                    </div>
                    <div className='flex justify-between border-b text-[#666666] py-1.5 font-poppins'>
                      <span>Shipping</span>
                      <span className='text-green-800'>{'Free'}</span>
                    </div>
                    <div className='flex justify-between font-normal text-lg py-1.5 font-poppins text-[#A1A1A1]'>
                      <span className='text-black font-medium'>Total</span>
                      <span className='text-[#552B18] font-medium'>
                        ₹
                        {states.ordersDataArr?.grand_total
                          ? Number(states.ordersDataArr?.grand_total).toFixed(2)
                          : '0.00'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Order Progress */}
              <div className='flex flex-1 items-center justify-center font-poppins my-2 w-full'>
                {/* Step 1 */}
                <div className='flex flex-col items-center flex-1 relative'>
                  <div
                    className={`w-6 h-6 sm:w-8 sm:h-8 z-10 rounded-full flex items-center justify-center text-sm sm:text-base font-medium transition-all duration-300
                   ${orderStatusCode.current >= ORDER_STATUS_ORDER_RECEIVED ? 'bg-[#552A16] text-white border-2 border-[#552A16]' : 'bg-white text-[#552A16] border-2 border-dashed border-[#552A16]'}`}
                  >
                    {orderStatusCode.current >= ORDER_STATUS_ORDER_RECEIVED ? (
                      <FaCheck size={12} />
                    ) : (
                      ORDER_STATUS_PROCESSING
                    )}
                  </div>
                  <span className='text-sm sm:text-base mt-1 sm:mt-2 text-center leading-tight'>Order Confirmed</span>
                  <div
                    className={`absolute top-3 sm:top-4 left-1/2 right-[-50%] h-[2px] sm:h-1 transition-all duration-300
                       ${orderStatusCode.current >= ORDER_STATUS_PROCESSING ? 'bg-[#552A16]' : 'bg-[#ECE0BD]'}`}
                  ></div>
                </div>

                {/* Step 2 */}
                <div className='flex flex-col items-center flex-1 relative'>
                  <div
                    className={`w-6 h-6 sm:w-8 sm:h-8 z-10 rounded-full flex items-center justify-center text-sm sm:text-base font-medium transition-all duration-300
                     ${orderStatusCode.current >= ORDER_STATUS_PROCESSING ? 'bg-[#552A16] text-white border-2 border-[#552A16]' : 'bg-white text-[#552A16] border-2 border-dashed border-[#552A16]'}`}
                  >
                    {orderStatusCode.current >= ORDER_STATUS_PROCESSING ? (
                      <FaCheck size={12} />
                    ) : (
                      ORDER_STATUS_ON_THE_WAY
                    )}
                  </div>
                  <span className='text-sm sm:text-base mt-1 sm:mt-2 text-center leading-tight'>Driver Assigned</span>
                  <div
                    className={`absolute top-3 sm:top-4 left-1/2 right-[-50%] h-[2px] sm:h-1 transition-all duration-300
                    ${orderStatusCode.current >= ORDER_STATUS_ON_THE_WAY ? 'bg-[#552A16]' : 'bg-[#ECE0BD]'}`}
                  ></div>
                </div>

                {/* Step 3 */}
                <div className='flex flex-col items-center flex-1 relative'>
                  <div
                    className={`w-6 h-6 sm:w-8 sm:h-8 z-10 rounded-full flex items-center justify-center text-sm sm:text-base font-medium transition-all duration-300
                        ${orderStatusCode.current >= ORDER_STATUS_ON_THE_WAY ? 'bg-[#552A16] text-white border-2 border-[#552A16]' : 'bg-white text-[#552A16] border-2 border-dashed border-[#552A16]'}`}
                  >
                    {orderStatusCode.current >= ORDER_STATUS_ON_THE_WAY ? (
                      <FaCheck size={12} />
                    ) : (
                      ORDER_STATUS_DELIVERED
                    )}
                  </div>
                  <span className='text-sm sm:text-base mt-1 sm:mt-2 text-center leading-tight'>
                    Order Out For Delivery
                  </span>
                  <div
                    className={`absolute top-3 sm:top-4 left-1/2 right-[-50%] h-[2px] sm:h-1 transition-all duration-300
                      ${orderStatusCode.current >= ORDER_STATUS_DELIVERED ? 'bg-[#552A16]' : 'bg-[#ECE0BD]'}`}
                  ></div>
                </div>

                {/* Step 4 */}
                {orderStatusCode.current !== ORDER_STATUS_CUSTOMER_REJECTED && (
                  <div className='flex flex-col items-center flex-1 relative'>
                    <div
                      className={`w-6 h-6 sm:w-8 sm:h-8 z-10 rounded-full flex items-center justify-center text-sm sm:text-base font-medium transition-all duration-300
                    ${orderStatusCode.current >= ORDER_STATUS_DELIVERED ? 'bg-[#552A16] text-white border-2 border-[#552A16]' : 'bg-white text-[#552A16] border-2 border-dashed border-[#552A16]'}`}
                    >
                      {orderStatusCode.current >= ORDER_STATUS_DELIVERED ? <FaCheck size={12} /> : 4}
                    </div>
                    <span className='text-sm sm:text-base mt-1 sm:mt-2 text-center leading-tight'>
                      {orderStatusCode.current === ORDER_STATUS_DELIVERED ? 'Delivered' : 'Deliver'}
                    </span>
                  </div>
                )}
                {orderStatusCode.current === ORDER_STATUS_CUSTOMER_REJECTED && (
                  <div className='flex flex-col items-center flex-1 relative'>
                    <div className='w-6 h-6 sm:w-8 sm:h-8 z-10 rounded-full flex items-center justify-center text-sm sm:text-base font-medium transition-all duration-300 bg-[#b50000] text-white border-2 border-[#b50000]'>
                      <GiCancel className='font-bold ' size={18} />
                    </div>
                    <span className='text-sm sm:text-base mt-1 sm:mt-2 text-center text-red-700 leading-tight'>
                      Rejected
                    </span>
                  </div>
                )}
              </div>

              {/* Product Table */}
              <div className='overflow-x-auto mt-8'>
                <table className='min-w-full text-left border'>
                  <thead className='bg-gray-100'>
                    <tr>
                      <th className='px-4 py-2 font-poppins font-medium text-gray-700'>IMAGE</th>
                      <th className='px-2 py-2 font-poppins font-medium text-gray-700'>PRODUCT</th>
                      <th className='px-4 py-2 font-poppins font-medium text-gray-700'>PRICE</th>
                      <th className='px-4 py-2 font-poppins font-medium text-gray-700'>QUANTITY</th>
                      <th className='px-4 py-2 font-poppins font-medium text-gray-700'>SUBTOTAL</th>
                    </tr>
                  </thead>
                  <tbody>
                    {states.productsList.map((item, idx) => (
                      <tr
                        key={idx}
                        className='border-t cursor-pointer'
                        onClick={() => states.gotoProductDetails(item.item_code)}
                      >
                        <td className='px-4 py-2 '>
                          <img
                            src={
                              item.website_image
                                ? `${SERVER_URL}${item.website_image}`
                                : `${SERVER_URL}${Namsteji_Manikchand_Icon}`
                            }
                            alt='---'
                            className='w-16 h-16 object-cover rounded'
                          />
                        </td>
                        <td className='pr-4 py-2 font-poppins'>{item.web_item_name}</td>
                        <td className='px-4 py-2 font-poppins'>
                          ₹{item.web_price ? Number(item.web_price).toFixed(2) : '0.00'}
                        </td>
                        <td className='px-4 py-2 font-poppins'>
                          <span className='flex items-center gap-1'>{item.quantity}</span>
                        </td>
                        <td className='px-8 py-2 font-poppins'>
                          ₹{item.tax_amount ? Number(item.tax_amount).toFixed(2) : '0.00'}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className='flex justify-between mt-4 px-4 pb-4 font-poppins'>
                  {orderStatusCode.current === ORDER_STATUS_DELIVERED && (
                    <>
                      <button
                        onClick={ratingReviewObj.handleOpenSlider}
                        className='px-4 py-2 text-[#4D4D4D] rounded-lg bg-[#E6EDF5] hover:bg-[#d3e3f4] text-sm font-poppins'
                      >
                        Rate Now
                      </button>

                      {/* <button className='flex items-center gap-1 text-sm px-4 py-2 text-[#4D4D4D] rounded-lg bg-[#E6EDF5] hover:bg-[#d3e3f4] font-poppins'>
                        <MdOutlineFileDownload size={16} />
                        <a
                          href={states.ordersDataArr?.sales_order_pdf_url}
                          download
                          target='_blank'
                          rel='noopener noreferrer'
                          className='text-[#4D4D4D]'
                        >
                          Invoice
                        </a>
                      </button> */}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Order Rating Componenet */}
      <OrderRatingReviewSlider
        productsList={states.productsList}
        isSliderOpen={ratingReviewObj.isSliderOpen}
        setIsSliderOpen={ratingReviewObj.setIsSliderOpen}
        reviews={ratingReviewObj.reviews}
        setReviews={ratingReviewObj.setReviews}
        handleSubmitRatingReview={ratingReviewObj.handleSubmitRatingReview}
        SERVER_URL={SERVER_URL}
        Namsteji_Manikchand_Icon={Namsteji_Manikchand_Icon}
      />

      <div className='block sm:block md:block lg:hidden'>
        <OrderDetailMobile
          ordersDataArr={states.ordersDataArr}
          productsList={states.productsList}
          navigate={states.navigate}
          gotoProductDetails={states.gotoProductDetails}
          orderStatusCode={orderStatusCode.current}
          handleOpenSlider={ratingReviewObj.handleOpenSlider}
        />
      </div>
    </>
  );
};

export default OrderDetailsPage;
